import { render } from "./PrivacyView.vue?vue&type=template&id=714e1ccd&scoped=true"
import script from "./PrivacyView.vue?vue&type=script&lang=js"
export * from "./PrivacyView.vue?vue&type=script&lang=js"

import "./PrivacyView.vue?vue&type=style&index=0&id=714e1ccd&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-714e1ccd"]])

export default __exports__